export default __webpack_public_path__ + "static/media/golo-table-red.3770b2af.png";